/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Response model for initializing a video upload.  Attributes:     videoId (str): The ID of the video that was created for upload.     status (str): The status of the upload initialization.
 */
export interface InitializeUploadDTO { 
    videoId: string;
    status: string;
}

